import React from 'react';
import { Input, Button, Select, Table, Tooltip } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { CompanyService } from 'services';
import { EditIcon, TrashIcon, ArrowLeft } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalCompanies extends React.Component<Props> {

	state = {
		form: {
			name: ''
		},
		item: null
	}
	
	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || ''
				},
				item: this.props.item
			});
		}
	}

	submit = async () => {
		const res: any = await CompanyService.admin.create({
			...this.state.form,
			// @ts-ignore
			company_id: this.state.item?.id || undefined
		});
		this.props.onClose();
		Globals.showSuccess(`Se ha ${ this.state.item != null ? 'modificado' : 'creado' } la empresa correctamente`);
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item,
			form: {
				...this.state.form,
				name: item?.name || ''
			}
		});
	}

	render() {
		return (
			<div id="modal-companies">
				<Input
					value={ this.state.form.name }
					label="Nombre"
					name="name"
					onChange={ this.change } />
				<div className="text-center">
					<Button type="submit" onClick={ this.submit }>
						Guardar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalCompanies;